export default {
  uploadMaxSizeMB: 5, // 画像の最大アップロードサイズ(MB)、 変更時はサーバー側も変更する
  toast: {
    showTime: 1500, // エディターのメッセージの表示時間
  },
  emptyImage: {
    width: 280, // 変更時はサーバー側も変更する
    height: 234, // 変更時はサーバー側も変更する
    url: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/emptyimage.png`,
  },
  emptyLogoImage: {
    width: 280, // 変更時はサーバー側も変更する
    height: 234, // 変更時はサーバー側も変更する
    url: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/emptylogoimage.png`,
  },
  maxTagsCount: 20,
  maxUrlLength: 2000,
  maxFileNameLength: 255, // 画像ファイル名
  maxAltLength: 255,
  maxTitleLength: 255,
  maxEmailLength: 255,
  maxEmailSubjectLength: 255,
  maxEmailBodyLength: 2000,
  maxContentInfoCommentLength: 256,
  minTelNumberDigits: 3, // 'tel:' と '+', '-' を除いた数字部分の桁数
  maxTelNumberDigits: 15,
  maxCodePartMPHEAttrCount: 50, // 1つのコードパーツに設定できる独自属性数 変更時はサーバー側も変更する
  maxTagLikeEmailCount: 10,
  xIcon: {
    attrs: {
      alt: 'X',
      href: 'http://www.x.com/',
      width: '32px',
      height: '32px',
      target: '_top',
      'data-link-kind': 'web',
      'data-sns-name': 'X',
      'data-share-alt': 'ポスト',
    },
    url: {
      color: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/color_x.png`,
      gray: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/gray_x.png`,
      white: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/white_x.png`,
    },
    hrefs: [
      'https://www.x.com',
      'https://www.twitter.com',
      'http://www.twitter.com',
      'http://www.x.com',
      'https://twitter.com',
      'https://x.com',
      'http://twitter.com',
      'http://x.com',
      'https://t.co',
      'http://t.co',
    ],
  },
  facebookIcon: {
    attrs: {
      alt: 'Facebook',
      href: 'http://www.facebook.com',
      width: '32px',
      height: '32px',
      target: '_top',
      'data-link-kind': 'web',
      'data-sns-name': 'Facebook',
      'data-share-alt': 'シェア',
    },
    url: {
      color: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/color_facebook.png`,
      black: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/black_facebook.png`,
      gray: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/gray_facebook.png`,
      white: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/white_facebook.png`,
    },
    hrefs: [
      'https://www.facebook.com',
      'http://www.facebook.com',
      'https://facebook.com',
      'http://facebook.com',
      'https://fb.com',
      'http://fb.com',
      'https://fb.me',
      'http://fb.me',
    ],
  },
  youtubeIcon: {
    attrs: {
      alt: 'YouTube',
      href: 'http://www.youtube.com',
      width: '32px',
      height: '32px',
      target: '_top',
      'data-link-kind': 'web',
      'data-sns-name': 'YouTube',
    },
    url: {
      color: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/color_youtube.png`,
      black: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/black_youtube.png`,
      gray: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/gray_youtube.png`,
      white: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/white_youtube.png`,
    },
    hrefs: [
      'https://www.youtube.com',
      'http://www.youtube.com',
      'https://youtube.com',
      'http://youtube.com',
      'https://youtu.be',
      'http://youtu.be',
    ],
  },
  instagramIcon: {
    attrs: {
      alt: 'Instagram',
      href: 'http://www.instagram.com',
      width: '32px',
      height: '32px',
      target: '_top',
      'data-link-kind': 'web',
      'data-sns-name': 'Instagram',
    },
    url: {
      color: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/color_instagram.png`,
      black: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/black_instagram.png`,
      gray: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/gray_instagram.png`,
      white: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/white_instagram.png`,
    },
    hrefs: [
      'https://www.instagram.com',
      'http://www.instagram.com',
      'https://instagram.com',
      'http://instagram.com',
    ],
  },
  lineIcon: {
    attrs: {
      alt: 'LINE',
      href: 'http://line.me',
      width: '32px',
      height: '32px',
      target: '_top',
      'data-link-kind': 'web',
      'data-sns-name': 'LINE',
      'data-share-alt': 'LINEで送る',
    },
    url: {
      color: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/color_line.png`,
    },
    hrefs: [
      'https://www.line.me',
      'http://www.line.me',
      'https://line.me',
      'http://line.me',
    ],
  },
  emailIcon: {
    attrs: {
      alt: 'Email',
      href: 'mailto:mailAddress@example.com',
      width: '32px',
      height: '32px',
      target: '_top',
      'data-link-kind': 'email',
      'data-sns-name': 'Email',
    },
    url: {
      color: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/color_email.png`,
      black: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/black_email.png`,
      gray: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/gray_email.png`,
      white: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/white_email.png`,
    },
    hrefs: [],
  },
  websiteIcon: {
    attrs: {
      alt: 'Website',
      href: 'http://example.com',
      width: '32px',
      height: '32px',
      target: '_top',
      'data-link-kind': 'web',
      'data-sns-name': 'Website',
    },
    url: {
      color: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/color_website.png`,
      black: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/black_website.png`,
      gray: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/gray_website.png`,
      white: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/white_website.png`,
    },
    hrefs: [],
  },
  telIcon: {
    attrs: {
      alt: 'Tel',
      href: 'tel:123-456-7890',
      width: '32px',
      height: '32px',
      target: '_top',
      'data-link-kind': 'tel',
      'data-sns-name': 'Tel',
    },
    url: {
      color: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/color_tel.png`,
      black: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/black_tel.png`,
      gray: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/gray_tel.png`,
      white: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snsicon/white_tel.png`,
    },
    hrefs: [],
  },
  snsLayoutIconTextImg: {
    horizontal: {
      black: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snslayout/icontext/horizontal/black.png`,
      white: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snslayout/icontext/horizontal/white.png`,
    },
    vertical: {
      black: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snslayout/icontext/vertical/black.png`,
      white: `${process.env.VUE_APP_S3_PUBLIC_URL}/common/snslayout/icontext/vertical/white.png`,
    },
  },
  partsContainer: {
    followButton: {
      containerStyleKeys: [
        'outer-background',
      ],
      wrapperStyleKeys: [
        'background',
        'border',
      ],
    }
  },
  part: {
    boxedText: {
      // テキストボックスの外側
      containerWrapperStyleKeys: [
        'padding-top',
        'padding-left',
        'padding-bottom',
        'padding-right',
      ],
      // ボックス部分
      containerStyleKeys: [
        'background',
        'border-top',
        'border-right',
        'border-bottom',
        'border-left',
      ],
      // テキスト部分
      innerStyleKeys: [
        'font-family',
        'font-size',
        'font-weight',
        'color',
        'font-style',
        'text-align',
        'line-height',
      ]
    },
    divider: {
      // 外側部分
      wrapperStyleKeys: [
        'background',
        'padding-top',
        'padding-bottom',
        'padding-right',
        'padding-left',
      ],
      // 罫線部分
      containerStyleKeys: [
        'border-top',
      ]
    },
    image: {
      defaultStyles: {
        'margin': '0 auto'
      },
      defaultAttrs: {
        'data-display-percent': 100
      },
      // ラッパーのstyle stylesの分別に使用
      wrapperStyleKeys: [
        'padding-top',
        'padding-right',
        'padding-bottom',
        'padding-left',
      ],
      // tdタグのstyle stylesの分別に使用
      tdStyleKeys: [
        'border-top',
        'border-right',
        'border-bottom',
        'border-left',
      ],
      // imgタグのstyle stylesの分別に使用
      imgStyleKeys: [
        'border-radius',
        'margin',
      ]
    },
    button: {
      // ボタン余白のスタイル
      paddingStyleKeys: [
        'padding-top',
        'padding-right',
        'padding-bottom',
        'padding-left',
      ],
      // ボタン本体のスタイル
      wrapperStyleKeys: [
        'background',
        'border-radius',
        'border-top',
        'border-right',
        'border-bottom',
        'border-left',
        'margin',
      ],
      // ボタン内側のスタイル
      containerStyleKeys: [
        'text-align',
      ],
      // ボタンテキストのスタイル
      innerStyleKeys: [
        'color',
        'font-family',
        'font-weight',
        'font-size',
        'font-style',
        'letter-spacing',
      ]
    },
    code: {
      textAttrName: 'data-mphe-edit',
      linkAttrName: 'data-mphe-link',
      imageAttrName: 'data-mphe-image',
      imageKeyAttrName: 'data-image-key',
      labelAttrName: 'data-mphe-label',
    }
  }
}
